module.exports = __webpack_public_path__ + "static/media/esaf.4341f199.jpg";